// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"cd83646d","488":"a7d42a58","885":"0b9d00de","949":"3ce426cf"}[chunkId] + ".chunk.js");